import type { Alert } from './schema';

export interface AlertGroup {
  readonly noteId: string | null;
  readonly alerts: readonly Alert[];
}

/**
 * Groups a flat alert page by the note each alert points at (mockup: "Abiertas tab: group
 * alerts by note"), preserving each group's first-seen order - the page already arrives newest
 * first, so a note's group sits wherever its most recent alert would have. Note-less alerts
 * (`note_id === null`, a purely system-level signal) group together at whatever position their
 * first one appears; the redesign's Sistema sheet is where that category actually surfaces now,
 * so in practice this list is empty for `status=open` once that migration is complete.
 */
export function groupAlertsByNote(alerts: readonly Alert[]): readonly AlertGroup[] {
  const order: (string | null)[] = [];
  const byNote = new Map<string | null, Alert[]>();
  for (const alert of alerts) {
    const key = alert.note_id;
    let bucket = byNote.get(key);
    if (bucket === undefined) {
      bucket = [];
      byNote.set(key, bucket);
      order.push(key);
    }
    bucket.push(alert);
  }
  return order.map((noteId) => ({ noteId, alerts: byNote.get(noteId) ?? [] }));
}
